import { cn } from "@tine/designsystem-utils";
import { observer } from "mobx-react-lite";
import { Link } from "wouter";

import { sendInternalLinkClick } from "../../common/tracking";
import type { MenuItem } from "../../common/types/cmsTypes";
import { titleCase } from "../../common/utils";

import MainColumn from "../../components/common/MainColumn";

import categoryStore from "../../stores/categories/categoryStore";
import contentStore from "../../stores/cms/contentStore";
import segmentStore from "../../stores/cms/segmentStore";

import productStore from "../../stores/product/productStore";
import theme from "../../themes/theme";

const itemCN = cn(["py-[--topnav-categories-padding-y]", "!text-headerFooterText"]);

const categoriesClassName = cn(["w-full bg-headerFooterBackground"]);

const categoriesNavigationContainerClassName = cn(["flex shrink-0 grow flex-row items-center", "w-full py-[--topnav-padding-y]"]);

const categoriesItemsClassName = cn(["flex w-full flex-row items-center justify-start gap-4"]);

const Categories = () => {
   const { categories } = categoryStore;
   const { mainMenuProductCategoryLevel } = theme;

   const categoryTree =
      mainMenuProductCategoryLevel === 0
         ? categories
         : (categories[0]?.children || categories).filter((cat) => productStore.resolveSkus(cat.skus, "viewable").length);

   const isMenuItemVisible = (menuItem: MenuItem) =>
      (menuItem.contentType === "v2_article" && segmentStore.isArticleVisible(menuItem.id)) ||
      menuItem.contentType !== "v2_article";

   return (
      <div className={categoriesClassName}>
         <MainColumn>
            <nav className={categoriesNavigationContainerClassName}>
               <div className={categoriesItemsClassName}>
                  {categoryTree.map((cat) => (
                     <div key={cat.id} className="py-[--topnav-categories-padding-y] font-medium">
                        <Link
                           className={itemCN}
                           to={cat.fullUrl}
                           onClick={() => sendInternalLinkClick(cat.fullUrl, "Navbar", titleCase(cat.name))}
                           data-testid="category-link"
                        >
                           {titleCase(cat.name)}
                        </Link>
                     </div>
                  ))}

                  {contentStore.mainMenuItems.map(
                     (menuItem) =>
                        isMenuItemVisible(menuItem) && (
                           <div key={menuItem.id}>
                              <Link
                                 className={itemCN}
                                 to={menuItem.url}
                                 onClick={() => sendInternalLinkClick(menuItem.url, "Navbar", menuItem.title)}
                              >
                                 {menuItem.title}
                              </Link>
                           </div>
                        )
                  )}
               </div>
            </nav>
         </MainColumn>
      </div>
   );
};

export default observer(Categories);
